import { Styling } from "./types";

export const metricStyle: Record<string, Styling> = {
  sent_connections: {
    label: "Invites",
    color: "#E316E3",
    color_background: "#FDE8FF",
    icon: "envelope-simple-open",
  },
  accepted_connections: {
    label: "Accepted",
    color: "#0DAC37",
    color_background: "#DAFEE3",
    icon: "check",
  },
  sent_messages: {
    label: "Messages",
    color: "#197DF7",
    color_background: "#DAF5FF",
    icon: "chat",
  },
  sent_inmails: {
    label: "InMails",
    color: "#642CFF",
    color_background: "#E0E1FF",
    icon: "envelope",
  },
  replies: {
    label: "Replies",
    color: "#DF7700",
    color_background: "#FFF4C6",
    icon: "arrow-u-up-right",
  },
  views: {
    label: "Profile views",
    color_background: "#FFF0E0",
    color: "#FF4D00",
    icon: "eye",
  },
};

export const metricKeys = [
  "views",
  "sent_connections",
  "accepted_connections",
  "sent_messages",
  "sent_inmails",
  "replies",
];

export const stateStyle: Record<string, Styling> = {
  CREATED: {
    label: "Ready",
    color: "#FF4D00",
    color_background: "#FFF0E0",
  },
  INIT: {
    label: "Draft",
    color: "#374151",
    color_background: "#F3F4F6",
  },
  SCHEDULED: {
    label: "Scheduled",
    color: "#32A3FF",
    color_background: "#DAF5FF",
  },
  ACTIVE: {
    label: "Active",
    color: "#0DAC37",
    color_background: "#EFFEF2",
  },
  PAUSED: {
    label: "Paused",
    color: "#FA9F06",
    color_background: "#FFF4C6",
  },
  ARCHIVED: {
    label: "Archived",
    color: "#6B7280",
    color_background: "#F3F4F6",
  },
};

export const unknownStateStyle: Styling = {
  label: "Unknown",
  color: "#374151",
  color_background: "#F3F4F6",
};

export const campaignStateStyle = (state: string): Styling =>
  stateStyle[state] ?? { ...unknownStateStyle, label: state || "Unknown" };

export const flowLabels: Record<string, Styling> = {
  PRIMARY_CONNECT: {
    label: "Connect Flow",
    tooltip:
      "Details about your connection request performance. If a follow-up sequence or InMail is added to the campaign, that information will also be included",
  },
  PRIMARY_MESSAGE: {
    label: "Message Flow",
    tooltip: "Details about all the messages and message requests performance",
  },
  INMAIL_OPTIMIZATION: {
    label: "InMail Flow",
    tooltip: "Details about your InMail performance",
  },
};
